/*
 * Copyright © 2019 Franck Borel, Martin Helfer, Sebastian Schüpbach
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {environment} from "../../shared/Environment";

/**
 * Provides dropdown menu for changing displayed rows per page
 */
@Component({
  selector: 'app-rows-per-page',
  template: `
    <div class="styled-select">
      <select
        [title]="'rows-per-page.title' | translate:{rowsPerPage: rowsPerPage}"
        #rowOpt
        (change)="updateRowsPerPage(+rowOpt.value)"
      >
        <option *ngFor="let rowOpt of rowOpts"
                [value]="rowOpt"
                [selected]="rowsPerPage == rowOpt">
          {{rowOpt}} {{ 'rows-per-page.label' | translate}}
        </option>
      </select>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowsPerPageComponent {
  @Input() rowsPerPage: number;
  @Output() changeRowsPerPage = new EventEmitter<number>();
  rowOpts = environment.rowOpts;

  updateRowsPerPage(no: number) {
    this.changeRowsPerPage.emit(no);
  }

}
